import gql from 'graphql-tag'

const REFUND_QUERY = gql`
  mutation journeyRefund($journeyId: ID!, $value: Int, $option: String!) {
    journeyRefund(id: $journeyId, value: $value, option: $option)
  }
`
export default REFUND_QUERY
